export default __webpack_public_path__ + "static/media/maintenance_started.478db9c4.svg";